import { render, staticRenderFns } from "./AsStampHistoryStatusList.vue?vue&type=template&id=74a56a2a"
import script from "./AsStampHistoryStatusList.vue?vue&type=script&lang=js"
export * from "./AsStampHistoryStatusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports